<template>
  <button @click="onClose" :class="class" class="btn btn_white newsletter__btn">
    <slot></slot>
  </button>
</template>

<script>
import EventDispatcher from '../eventDispatcher.js'

export default {
  name: 'CloseButton',
  props: {
    onCloseCallback: {
      type: Function
    },
    class: {
      type: String
    }
  },
  methods: {
    onClose() {
      EventDispatcher.dispatch('FormClosed')

      if (this.onCloseCallback) {
        this.onCloseCallback()
      }
    }
  }
}

</script>


// WEBPACK FOOTER //
// CloseButton.vue?8a3725f0